export default function About() {
  return (
    <div className="container__policy">
      <h1>About</h1>
      <p>
       # About AI & Tech Today
      </p>
      <br />
      <p>
       AI & Tech Today is an educational website focused on helping people understand and use modern AI tools.

We publish tutorials, explainers, and comparisons to make AI more accessible for beginners, professionals, and curious learners.

Our goal is clarity over hype. We strive to provide accurate, unbiased information to help you make informed decisions about AI technologies.
      </p>
    </div>
  );
}